/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The EmailsChecksBody model module.
 * @module model/EmailsChecksBody
 * @version 1.0.0
 */
export class EmailsChecksBody {
  /**
   * Constructs a new <code>EmailsChecksBody</code>.
   * @alias module:model/EmailsChecksBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EmailsChecksBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EmailsChecksBody} obj Optional instance to populate.
   * @return {module:model/EmailsChecksBody} The populated <code>EmailsChecksBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EmailsChecksBody();
      if (data.hasOwnProperty('emails'))
        obj.emails = ApiClient.convertToType(data['emails'], ['String']);
      if (data.hasOwnProperty('file'))
        obj.file = ApiClient.convertToType(data['file'], 'Blob');
      if (data.hasOwnProperty('fieldsMap'))
        obj.fieldsMap = ApiClient.convertToType(data['fieldsMap'], 'String');
      if (data.hasOwnProperty('settings'))
        obj.settings = ApiClient.convertToType(data['settings'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Array.<String>} emails
 */
EmailsChecksBody.prototype.emails = undefined;

/**
 * @member {Blob} file
 */
EmailsChecksBody.prototype.file = undefined;

/**
 * @member {String} fieldsMap
 */
EmailsChecksBody.prototype.fieldsMap = undefined;

/**
 * @member {String} settings
 */
EmailsChecksBody.prototype.settings = undefined;

